<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'plan'} ">戻る</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{menuNameUpper}}</p>
                    <p class="menu_center_tex_l">{{menuNameLower}}</p>
                </div>
                <div class="menu_right">
                </div>
            </div>
        </div>
        <div class="main_unit">
            <div class="top_unit">
                <div class="top_name_box">{{getStaffName}}</div>
                <div class="top_center_box"> </div>
            </div>
            <div class="tenpo_check_menu1">               
                <ul>
                    <li v-for="menu in dailyCheckButtonList" :key="menu.daily_check_button_id" :class="dailyCheckButtonLength" >
                        <div v-if="menu.dailyCheckButtonNo === 99">
                        <input type="button" :class="monthlyClass"
                            @click.prevent.stop="pageDialogOpen($route.params.menuId,menu.dailyCheckButtonId,menu.dailyCheckButtonName,menu.dailyCheckButtonName)" :value="menu.dailyCheckButtonName">
                        </div>
                        <div v-else>
                            <input type="button" :class="classList['classType'][menu.dailyCheckButtonNo-1]"
                            @click.prevent.stop="pageDialogOpen($route.params.menuId,menu.dailyCheckButtonId,menu.dailyCheckButtonName,menu.dailyCheckButtonName)" :value="menu.dailyCheckButtonName">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd600">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit" style="width: 350px">{{selectButtonName}}</p>
                        </div>
                        <div class="modal_header_left">
                            <a class="js-modal-close" role="button" @click.prevent.stop="closeModel">閉じる</a>
                        </div>
                    </div>
                    <div  v-if="dailyCheckPageList.length === 0"  class="btn_submit_nodata_height">
                        <div class="modal_content_tex btn_submit_height">
                            <p>表示するページがありません</p><br>
                            <p>店舗（店舗管理者権限）では表示設定を変更できません。必要に応じ、本部等の管理者様（企業管理者権限を持つ担当者様）にお問い合わせください。</p>
                        </div>
                    </div>
                    <div v-else class="btn_submit_height">
                        <div class="btn_submit_height btn_submit_overflow">
                            <div v-for="(list,index) in dailyCheckPageList" :key="index" >
                                <div v-if="list.dailyCheckPageNo !== 21" class="btn_submit3" style="float: left;">
                                    <router-link class="btn_submit3_bg_free" style="border:2px solid #062333" :to="{ name: 'dailyCheckMenuInputSnap',
                                    params: {menuId:selectMenuId,subMenuId: selectSubMenuId,title:selectTitle,page:index+1}}">{{index + 1}} {{list.dailyCheckPageName}}</router-link>
                                </div>
                                <div v-if="list.dailyCheckPageNo === 21" class="btn_submit3" style="float: left;">
                                    <router-link class="btn_submit3_bg_free" style="border:2px solid #062333" :to="{ name: 'dailyCheckFreeCommentSnap',
                                    params: { menuId: selectMenuId, subMenuId: selectSubMenuId }}">{{index + 1}} フリーコメント</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import PulseLoader from '@/app/components/PulseLoader.vue'
    export default {
        name: 'dailyCheckMenuSnapIndex',
        components: {
            PulseLoader
        },
        data: function () {
            return {
                classList: {
                    classType: [
                        'tenpo_bg01',
                        'tenpo_bg02',
                        'tenpo_bg03',
                        'tenpo_bg04',
                        'tenpo_bg05',
                        'tenpo_bg06',
                    ]
                },
                monthlyClass: 'tenpo_bg99',
                dailyCheckButtonList: [],
                showContent:false,
                selectMenuId:null,
                selectSubMenuId:null,
                selectTitle:"",
                selectButtonName:"",
                dailyCheckPageList:[],
                isLoading:false,
            }
        },
        props: {
            menuId: Number,
        },
        computed: {
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            },
            getStaffName:function () {
                return  this.$store.getters['staff/name'];
            },
            brandPath: function () {
                return this.$store.getters['brand/path'];
            },
            dailyCheckButtonLength: function () {
                return this.dailyCheckButtonList.length === 7 ? 'col-3':'col-4';
            },
        },
        mounted () {

            var brandId = this.$store.getters['brand/id'];
            var topButtonId = this.$route.params.menuId;
            var storeId = this.$store.getters['store/id'];
            var datetime = this.dateFormat();

            var url = this.$apiEndpoint + 'user/brand/' + brandId + '/top/' + topButtonId + '/daily_menu/' + storeId + '?datetime=' + datetime;

            this.$axios
                .get(url)
                .then(response => {
                    this.dailyCheckButtonList = response.data.dailyCheckButtonList
                    this.$store.dispatch('buttons/set', { key: 'dailyCheckMenu', list: { [topButtonId]: this.dailyCheckButtonList } })
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                });

        },
        methods:{
            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            },
            async pageDialogOpen(menuId,subMenuId,title,buttonName){

                this.isLoading = true;
                var apiResponseFlg = true;
                this.dailyCheckPageList = [];

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/id'];
                var dailyCheckButtonId = subMenuId;
                var datetime = this.dateFormat();
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/daily_menu/' + dailyCheckButtonId + '/page?datetime=' + datetime;
                await this.$axios
                    .get(url)
                    .then(response => {
                        this.dailyCheckPageList = response.data.dailyCheckPageList
                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        apiResponseFlg = false;
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){

                    // メニュー情報を一時格納
                    this.selectMenuId = menuId
                    this.selectSubMenuId = subMenuId
                    this.selectTitle = title
                    this.selectButtonName = buttonName

                    // ダイアログ
                    this.showContent = true;
                }
            },
            closeModel(){
                // メニュー情報を初期化
                this.selectMenuId = null;
                this.selectSubMenuId = null;
                this.selectTitle = ""
                this.selectButtonName = "";
                // ダイアログ非表示
                this.showContent = false;
            },
        }
    }
</script>
